import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme: Theme) => ({
    noticeContainer: {
      padding: '1.4rem 1.5rem',
    },
    headingContainer: {
      marginBottom: '0.3rem',
      display: 'flex',
      gap: '0.5rem',
    },
    headingIconInfo: {
      alignSelf: 'center',
      color: theme.palette.primary.main,

      '@media (max-width: 538px)': {
        alignSelf: 'auto',
        marginTop: '0.25rem'
      },
    },
    infoHeading: {
          fontWeight: 700,
    },
    infoMessage: {
      fontWeight: 400,
      fontSize: '16px',
      fontFamily: 'fs-elliot-pro-regular !important',
      lineHeight: '1.5rem',
    },
    default: {
      border: `2px solid ${theme.palette.light[400]}`,
      backgroundColor: theme.palette.light[100],
    },
    info: {
      border: `2px solid ${theme.palette.primary.main}`,
      backgroundColor: theme.palette.primary.contrastText,
    },
    error: {
      border: `2px solid ${theme.palette.utility.redLight}`,
      backgroundColor: theme.palette.utility.noticeError,
    },
  }),
  { index: 1 },
);
